import { Alert, Stepper } from "@mui/material";
import { useRecordContext } from "react-admin";
import FlowStep from "./FlowStep";
import { SectionTitle } from "features/SectionTitle";

// The flow as an ordered spine. Every step renders expanded (`activeStep={-1}` plus `expanded` on each Step)
// rather than as a wizard: this is a visualisation of history, and an operator needs the whole chain at once to
// see where it stopped.
const FlowStepper = () => {
  const record = useRecordContext();

  if (!record) return null;

  const steps = [...(record.steps ?? [])].sort((a, b) => a.order - b.order);

  // A flow with no steps is deliberate, not broken: reconciliation records a coverage gap it must not act on
  // as a step-less parked flow, because there is nothing to execute — only something for a human to decide.
  if (steps.length === 0) {
    return (
      <>
        <SectionTitle
          title="Стъпки"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Alert severity="info">
          Потокът няма стъпки. Така се записва проблем, който не може да бъде решен автоматично — няма какво да
          бъде изпратено към НАЦИД, необходимо е решение от човек.
        </Alert>
      </>
    );
  }

  return (
    <>
      <SectionTitle
        title="Стъпки"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Stepper
        orientation="vertical"
        nonLinear
        activeStep={-1}
        sx={{ mt: 2 }}
      >
        {steps.map(step => (
          <FlowStep
            key={step.id}
            step={step}
            flowId={record.id}
          />
        ))}
      </Stepper>
    </>
  );
};

export default FlowStepper;
